import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "accent" | "outline" | "text" | "success" | "error";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  loading?: boolean;
}

const sizeClasses = {
  sm: "px-3 py-1 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-5 py-3 text-lg",
};

const baseClasses =
  "font-semibold rounded focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center transition";

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled,
  children,
  className = "",
  ...rest
}) => {
  const variantClasses = {
    primary: "bg-primary text-cardBackground hover:bg-primary/90 focus:ring-primary",
    secondary: "bg-secondary text-cardBackground hover:bg-secondary/90 focus:ring-secondary",
    accent: "bg-accent text-cardBackground hover:bg-accent/90 focus:ring-accent",
    outline:
      "border border-primary text-primary bg-transparent hover:bg-primary hover:text-cardBackground focus:ring-primary",
    text: "bg-transparent text-primary hover:underline focus:ring-transparent shadow-none",
    success: "bg-successText text-cardBackground hover:bg-green-600 focus:ring-green-500",
    error: "bg-errorText text-cardBackground hover:bg-red-700 focus:ring-red-600",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${
        fullWidth ? "w-full" : ""
      } ${className}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && (
        <svg
          className="animate-spin mr-2 h-5 w-5 text-current"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8z"
          ></path>
        </svg>
      )}
      {children}
    </button>
  );
};
